import { render, staticRenderFns } from "./ExternalServiceRoomadmin.vue?vue&type=template&id=ad98456e&"
import script from "./ExternalServiceRoomadmin.vue?vue&type=script&lang=js&"
export * from "./ExternalServiceRoomadmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports